import { useI18n } from "@/hooks/useI18n";
import "./api.key.list.scss";
import { useMemo, useState } from "react";
import { Flex, Image, Text, chakra } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useMedia } from "@/hooks/useMedia";
import dayjs from "dayjs";
import DelApiKeyModal from "./DelApiKeyModal";

const MockAddressList = [
  {
    email: "haopeiwei@qq,com",
    tagName: "23123_sda",
    apiKey: "open",
    date: "231231",
  },
  {
    email: "xyz",
    tagName: "23123_sda",
    apiKey: "close",
    date: "231231",
  },
  {
    email: "haopeiwei@qq,com",
    tagName: "23123_sda",
    apiKey: "open",
    date: "231231",
  },
];

const ItemText = chakra(Text, {
  baseStyle: {
    color: "#010313",
    fontSize: "14px",
  },
});

const OperateWrap = chakra(Flex, {
  baseStyle: {
    width: "100%",
    gap: "20px",
    padding: "0px 20px",
    justifyContent: "center",
    img: {
      cursor: "pointer",
    },
  },
});

const SubAccountApiKeyList = ({ searchValue }) => {
  const { t } = useI18n();
  const [addressList, setAddressList] = useState(MockAddressList);
  const navigator = useNavigate();
  const { isMobile } = useMedia();
  const [showDelModal, setShowDelModal] = useState(false); // 删除
  const [delInfo, setDelInfo] = useState({});

  const memoTexts = useMemo(() => {
    return [t("登录邮箱"), t("标签名"), "API Key", t("创建日期"), t("操作")];
  }, [t]);

  const formatApiKeyStr = (key) => {
    return key.slice(0, 4) + "****" + key.slice(-4);
  };

  const filterList = useMemo(() => {
    if (searchValue) {
      return MockAddressList.filter(
        (d) =>
          d.email.indexOf(searchValue) > -1 ||
          d.tagName.indexOf(searchValue) > -1 ||
          d.apiKey.indexOf(searchValue) > -1
      );
    }
    return MockAddressList;
  }, [searchValue, MockAddressList]);

  const renderOperateMain = (item) => {
    return (
      <OperateWrap>
        <Image
          src="../../wwwsite/images/whitelist/edit2.svg"
          w={"24px"}
          h={"24px"}
        />
        <Image
          src="../../wwwsite/images/whitelist/trash2.svg"
          w={"24px"}
          h={"24px"}
          onClick={() => {
            setDelInfo(item);
            setShowDelModal(true);
          }}
        />
      </OperateWrap>
    );
  };

  return (
    <>
      <div
        className="sub-account-api-key-list"
        style={{ minHeight: addressList.length === 0 ? "200px" : "0px" }}
      >
        <div className="header">
          {memoTexts.map((d, i) => {
            return (
              <Text fontSize={"14px"} color={"#7B7C8F"} key={i}>
                {d}
              </Text>
            );
          })}
        </div>
        <div className="body">
          {filterList?.length > 0 &&
            filterList.map((item) => {
              return (
                <Flex
                  fontSize={"14px"}
                  color={"#7B7C8F"}
                  _hover={{
                    cursor: "pointer",
                    backgroundColor: "rgba(32, 26, 85, 0.05) !important",
                  }}
                  key={item.tagName}
                  className="row"
                >
                  <ItemText>{item.email}</ItemText>
                  <ItemText>{item.tagName}</ItemText>
                  <ItemText>{formatApiKeyStr(item.apiKey)}</ItemText>

                  <ItemText>
                    {dayjs(item.date).format("YYYY-MM-DD HH:mm")}
                  </ItemText>
                  <Flex
                    gap={"15px"}
                    backgroundColor={isMobile ? "#fff" : ""}
                    className="last"
                    justifyContent={"center"}
                  >
                    {renderOperateMain(item)}
                  </Flex>
                </Flex>
              );
            })}
          {!addressList.length && (
            <Text color={"#010313"} fontSize={"14px"} className="no-data">
              {t("BVmyvtMVCbAJXhwSpT")}
            </Text>
          )}
        </div>
      </div>

      <DelApiKeyModal
        show={showDelModal}
        onCancel={() => setShowDelModal(false)}
        delInfo={delInfo}
      ></DelApiKeyModal>
    </>
  );
};

export default SubAccountApiKeyList;
